import { Link } from "react-router-dom";
import { LogoDark } from "./Logo";
import { PRODUCTS } from "@/data/products";

export const Footer = () => (
  <footer className="relative bg-[#070B2E] text-[#C9CDEA] overflow-hidden grain" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10 relative">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <LogoDark />
          <p className="mt-6 max-w-sm leading-relaxed">
            Molntjänster för redovisningskonsulter – kvalitetssäkring, Penningtvättlagen och AI-avstämning. Skapat utifrån över 38 års erfarenhet som redovisningskonsult och företagare och 18 års erfarenhet som kvalitetskontrollant.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#7FE3EA] mb-5">Produkter</p>
          <ul className="space-y-3">
            {PRODUCTS.map((p) => (
              <li key={p.slug}><Link className="hover:text-white transition-colors" to={`/produkter/${p.slug}`} data-testid={`footer-link-${p.slug}`}>{p.short}</Link></li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#7FE3EA] mb-5">Redoc</p>
          <ul className="space-y-3">
            <li><Link className="hover:text-white transition-colors" to="/#faq" data-testid="footer-link-faq">FAQ</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/#tjanster">Tjänster</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/nyheter" data-testid="footer-link-nyheter">Nyheter</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/kontakt" data-testid="footer-link-kontakt">Kontakt</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-white/10 grid grid-cols-1 sm:grid-cols-3 items-center gap-4 text-sm text-[#A9B0D6]">
        <span className="hidden sm:block" />
        <div className="text-center space-y-1.5" data-testid="footer-copyright">
          <p className="text-[#E3E6F7]">© 2026 Redoc TM AB</p>
          <p>
            Web by{" "}
            <a href="https://logartgroup.com/" target="_blank" rel="noopener noreferrer" className="text-[#5B8DEF] hover:text-[#7FA8FF] underline-offset-4 hover:underline transition-colors" data-testid="footer-web-by-link">Logardt Group</a>
          </p>
        </div>
        <Link to="/admin/login" className="justify-self-center sm:justify-self-end hover:text-white transition-colors" data-testid="footer-admin-link">Admin</Link>
      </div>
    </div>
  </footer>
);
